import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { faWindowClose } from "@fortawesome/free-solid-svg-icons";

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
    standalone: false
})
export class ConfirmDialogComponent  {
  message = "Are you sure?";
  title = '';
  confirmText = "confirm";
  cancelText = "cancel";
  showInput = false;
  useTextarea = false;
  inputValue = '';
  inputPlaceholder = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ConfirmDialogComponent>
  ) {
    if (data.message || data.dialogMessage) {
      this.message = data.message || data.dialogMessage;
    }
    if (data.title) {
      this.title = data.title;
    }
    if (data.confirmText !== undefined) {
      this.confirmText = data.confirmText;
    }
    if (data.cancelText) {
      this.cancelText = data.cancelText;
    }
    if (data.showInput) {
      this.showInput = data.showInput;
    }
    if (data.inputValue) {
      this.inputValue = data.inputValue;
    }
    if (data.inputPlaceholder) {
      this.inputPlaceholder = data.inputPlaceholder;
    }
    if (data.useTextarea) {
      this.useTextarea = data.useTextarea;
    }
  }

  faWindowClose = faWindowClose;

  onConfirm(): void {
    if (this.showInput) {
      this.dialogRef.close(this.inputValue);
    } else {
      this.dialogRef.close(true);
    }
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
